import { FC } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { LoadingSpinner, SubTitle } from '@components';
import { useGetCustomerLogsQuery } from '@services/activity-log/activity-log';
import { Customer } from '@models';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { isoStringToLegibleString } from '@helpers';
import React from 'react';

type Props = {
  selectedCustomer: Customer;
};

export const ActivityLogPage: FC<Props> = ({ selectedCustomer }) => {
  const { data: Logs } = useGetCustomerLogsQuery({ customerId: selectedCustomer.id.toString() });

  const columns: GridColDef[] = [
    {
      field: 'dateTime',
      renderHeader: () => (
        <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 600 }}>
          {'Date'}
        </Typography>
      ),
      flex: 0.5,
      valueFormatter: ({ value }) => isoStringToLegibleString(value),
    },
    {
      field: 'jimboUser',
      renderHeader: () => (
        <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 600 }}>
          {'Jimbo User'}
        </Typography>
      ),
      flex: 0.5,
      renderCell: (it) => {
        const { value } = it;
        return (
          <Tooltip title={value}>
            <Box display={'flex'} justifyContent={'center'}>
              <span>{value}</span>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: 'action',
      renderHeader: () => (
        <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 600 }}>
          {'Action'}
        </Typography>
      ),
      flex: 0.5,
    },
    {
      field: 'url',
      renderHeader: () => (
        <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 600 }}>
          {'URL'}
        </Typography>
      ),
      flex: 0.5,
      renderCell: (it) => {
        const { value } = it;
        return (
          <Tooltip title={value}>
            <Box display={'flex'} justifyContent={'center'}>
              <span>{value}</span>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: 'description',
      renderHeader: () => (
        <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 600 }}>
          {'Description'}
        </Typography>
      ),
      flex: 1,
      renderCell: (it) => {
        const { value } = it;
        return (
          <Tooltip title={value}>
            <Box display={'flex'} justifyContent={'center'}>
              <span>{value}</span>
            </Box>
          </Tooltip>
        );
      },
    },
  ];
  return (
    <React.Fragment>
      <SubTitle title="Activity Logs" />
      <Box overflow="hidden" height="calc(100vh - 200px)" display="flex" data-testid="log-view">
        {Logs ? (
          <Box height="90%" width="100%" display="flex" gap={2}>
            <DataGrid
              rowHeight={40}
              rows={Logs}
              columns={columns}
              headerHeight={50}
              disableSelectionOnClick
              sx={{
                '&.MuiDataGrid-root': {
                  border: 'none',
                },
                '.MuiDataGrid-columnSeparator': {
                  display: 'none',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#CD9BF0',
                  color: '#161616',
                },
                '& .MuiDataGrid-row': {
                  '&:nth-child(2n)': { backgroundColor: 'rgba(235, 235, 235, .7)' },
                  '&:hover': {
                    backgroundColor: '#faf2ff',
                  },
                },
              }}
            />
          </Box>
        ) : (
          <LoadingSpinner isOpen={true} />
        )}
      </Box>
    </React.Fragment>
  );
};
